import { render, staticRenderFns } from "./ExamPlaceManagerSlidebar.vue?vue&type=template&id=06133d8e"
import script from "./ExamPlaceManagerSlidebar.vue?vue&type=script&lang=js"
export * from "./ExamPlaceManagerSlidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports